import { motion } from "framer-motion";
import { Cpu, Cloud, Home, Workflow, Bot, Server } from "lucide-react";

const NODES = [
  { id: "ai", icon: Bot, label: "AI", x: 50, y: 50, r: 0 },
  { id: "cloud", icon: Cloud, label: "Cloud", x: 50, y: 12, r: 1 },
  { id: "devices", icon: Home, label: "Smart Home", x: 86, y: 34, r: 2 },
  { id: "auto", icon: Workflow, label: "Automation", x: 82, y: 78, r: 3 },
  { id: "sw", icon: Server, label: "Software", x: 30, y: 86, r: 4 },
  { id: "compute", icon: Cpu, label: "Compute", x: 12, y: 40, r: 5 },
];

export default function EcosystemGraphic() {
  return (
    <div className="relative aspect-square w-full max-w-xl" data-testid="ecosystem-graphic">
      <div className="pointer-events-none absolute inset-0 rounded-[2rem] accent-bg opacity-20 blur-3xl" />
      <div className="relative h-full w-full rounded-[2rem] border border-white/10 bg-[#0B1220]/80 p-4 backdrop-blur-xl grain overflow-hidden">
        <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full">
          {NODES.slice(1).map((n) => (
            <line key={n.id} x1="50" y1="50" x2={n.x} y2={n.y}
              stroke="rgba(148,163,184,0.25)" strokeWidth="0.4" className="animate-dash" />
          ))}
        </svg>

        {NODES.map((n, i) => {
          const Icon = n.icon;
          const center = n.id === "ai";
          return (
            <motion.div
              key={n.id}
              className="absolute -translate-x-1/2 -translate-y-1/2"
              style={{ left: `${n.x}%`, top: `${n.y}%` }}
              initial={{ opacity: 0, scale: 0.4 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.4 + i * 0.12, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className={`relative grid ${center ? "h-16 w-16" : "h-12 w-12"} place-items-center rounded-2xl border ${center ? "accent-bg border-transparent" : "border-white/10 bg-white/5"} backdrop-blur`}>
                {center && <span className="absolute inset-0 rounded-2xl accent-bg animate-pulse-ring" />}
                <Icon size={center ? 26 : 18} className={center ? "text-[#07111F]" : "text-cyan-300"} strokeWidth={2} />
              </div>
              <span className="mt-2 block whitespace-nowrap text-center text-[10px] font-medium tracking-wide text-slate-400">
                {n.label}
              </span>
            </motion.div>
          );
        })}

        <div className="absolute bottom-4 left-4 right-4 rounded-2xl border border-white/10 bg-[#07111F]/70 p-3 backdrop-blur">
          <div className="flex items-center gap-2 text-[10px] font-mono text-slate-400">
            <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
            <span>ecosystem.status</span>
            <span className="ml-auto text-emerald-300">all systems connected</span>
          </div>
        </div>
      </div>
    </div>
  );
}
